import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import {
  addNewAmenities,
  viewAmenity,
} from "../../Redux/Actions/amenitiesActions";
import ImageShowerModal from "../../Global Functions/imageShowerModal";
import toast from "react-hot-toast";
import SelectInput from "../../Global Functions/selectInput";
import { viewSubCategoryList } from "../../Redux/Actions/categoryActions";

const AddSubAmenities = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(viewAmenity(id));
  }, [id, dispatch]);

  const { amenity } = useSelector((state) => state.amenities || {});

  const { subCategories } = useSelector((state) => state.categories || {});

  const [amenityData, setAmenityData] = useState({
    name: amenity?.data?.amenities_for,
    position: Math.floor(Math.random() * 1000) + 1,
    amenities_for: "",
    image: "",
    parent: id,
    category: "",
  });

  useEffect(() => {
    if (amenity?.data) {
      const payload = {
        page: 1,
        limit: 1000,
        category_id: amenity?.data?.project_type,
      };

      dispatch(viewSubCategoryList(payload));
    }
    if (amenity?.data?.amenities_for) {
      setAmenityData((prevData) => ({
        ...prevData,
        amenities_for: amenity.data.amenities_for,
      }));
    }
  }, [amenity?.data, dispatch]);

  const navigate = useNavigate();

  const handleFileChange = async (event) => {
    const uploadedImage = event.target.files[0];

    if (uploadedImage) {
      const imageUrl = await AddImage(uploadedImage);
      if (imageUrl) {
        setAmenityData((prevData) => ({ ...prevData, image: imageUrl }));
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const filteredPayload = amenityData
      ? Object.fromEntries(
          Object.entries(amenityData).filter(
            ([_, value]) =>
              value !== null && value !== undefined && value !== ""
          )
        )
      : [];
    try {
      const response = await dispatch(addNewAmenities(filteredPayload));

      if (response.statusCode === 200) {
        navigate(`/amenities/view/${id}`);
      } else {
        toast.error(response?.message);
      }
      setAmenityData({
        name: "",
        position: Math.floor(Math.random() * 1000) + 1,
        amenities_for: "",
        image: "",
        parent: id,
      });
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setAmenityData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 border-24 padding-20" style={{ width: "100%" }}>
        <div className="flex-container flex-justify-between align-center">
          <h1>{amenity?.data?.name || "Add Sub Amenity"}</h1>

          <button onClick={() => navigate(-1)} className="button-class">
            View Sub-Amenities List
          </button>
        </div>
        <div>
          <form onSubmit={handleSubmit}>
            <span className="span-class">Amenity For</span>
            <input
              value={amenity?.data ? amenity.data.amenities_for : "No Data"}
              disabled
              className="input-class"
            />
            <div className="flex-container flex-justify-between gap-10">
              <div style={{ width: "33%" }}>
                <span className="span-class" htmlFor="subcategory-name">
                  Sub Amenities Name
                </span>
                <input
                  onChange={handleAddChange}
                  className="input-class"
                  type="text"
                  name="name"
                  placeholder="Enter Title"
                />
              </div>
              <div style={{ width: "33%" }}>
                <SelectInput
                  label="Select Category"
                  name="category"
                  placeholder="Select an Option"
                  value={amenityData.category}
                  options={
                    Array.isArray(subCategories?.data)
                      ? subCategories.data.map((amenity) => ({
                          label: amenity.name,
                          value: amenity._id,
                        }))
                      : []
                  }
                  onChange={handleAddChange}
                ></SelectInput>
              </div>
              <div style={{ width: "33%" }}>
                <span className="span-class" htmlFor="add-image">
                  Upload Sub-Amenity's Icon
                </span>
                <input
                  style={{
                    display: "none",
                  }}
                  onChange={handleFileChange}
                  type="file"
                  id="image"
                  name="image"
                />
                <label className="label-class-image" for="image">
                  Click to Upload Icon
                </label>
                {amenityData?.image ? (
                  <ImageShowerModal
                    file={amenityData.image}
                    onClick={() =>
                      setAmenityData((prevData) => ({ ...prevData, image: "" }))
                    }
                  ></ImageShowerModal>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="flex-end margin-h-10">
              <Link to="/amenities">
                <button className="button-class-white">Cancel</button>
              </Link>
              <button className="button-class" type="submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddSubAmenities;
